import NodesView from 'components/NodesView';
import { CheckRadio } from 'screens/home/tasksList/styles';
import styled, { css } from 'styled-components';
import { StyledTypography, StrikethroughCSS2, GutterCSS } from 'styles/common';

export const StyledNodesView = styled(NodesView)`
  display: inline-flex;
  margin-right: 0.25rem;
  height: ${(props) => props.height ?? '20px'};
  vertical-align: baseline !important;
  ${(props) => props.theme.breakpoints.down('xs')} {
    margin: 0;
  }
`;

export const TasksContainer = styled.div`
  border-radius: 5px;
  font-size: 0.75rem;
  ${(props) =>
    props.disabled &&
    css`
      pointer-events: none;
      cursor: initial;
      opacity: 0.5;
    `};
`;

export const StyledCheckRadio = styled(CheckRadio)`
  vertical-align: top;
  padding: 3px 6px 6px 1px;
`;

export const Link = styled.a`
  cursor: pointer;
  color: #0992f0;
  font-size: 0.725rem;
  display: inline-block;
  &:hover {
    text-decoration: underline;
  }
  ${(props) =>
    props.marginLeft &&
    css`
      margin-left: 8px;
      margin-top: 5px;
    `};
  ${(props) =>
    props.disabled &&
    css`
      opacity: 0.6;
      pointer-events: none;
    `}
  ${GutterCSS};
`;

export const DisplayActions = styled.span`
  display: none;
  margin-top: 2px;
  // margin-left: 0.75rem;
`;

export const TextDiv = styled.div`
  display: inline;
  max-width: 80%;
  vertical-align: text-top;
  & > * {
    vertical-align: super;
  }
  // align-items: center;
  margin-top: 0.2rem;
  flex-wrap: wrap;
`;

export const StyledTypography1 = styled(StyledTypography)`
  font-size: 0.75rem;
  margin-bottom: 5px;
  min-height: 20px;
  ${(props) =>
    props.nomargin &&
    css`
      margin-bottom: 0;
    `};
  ${(props) => props.strikeCss && StrikethroughCSS2}
`;

export const TextFieldAndActions = styled.div`
  display: inline-flex;
  align-items: flex-start;
  width: 90%;
`;

export const Actions = styled.div`
  display: inline-flex;
  align-items: flex-start;
`;

export const DueDateContainer = styled.div`
  display: inline-flex;
  align-items: center;
  margin-right: 0.25rem;
  padding: 2px;
  background: #f7f7f7;
  border-radius: 4px;
  border: 1px solid #ddd;
  padding-right: 5px;
  margin-left: 5px;
`;

export const SubTaskContainer = styled.div`
  margin-bottom: 0.8rem;
  display: flex;
  align-items: flex-start;
  &:hover > ${DisplayActions} {
    display: inline;
  }
`;

export const SubTaskCheck = styled(StyledCheckRadio)`
  padding: 4px 6px 0 0;
`;
